import { useState } from 'react';

const faqs = [
  {
    q: '豆花视频是什么？和其他视频平台有什么区别？',
    a: '豆花视频是一个视频聚合平台，主要聚合香蕉视频、红桃视频、蜜桃视频、西瓜视频、糖豆视频、樱桃视频、蘑菇视频等美食命名视频平台的内容。我们不做原创内容，而是帮你把各大平台的电视剧全集和最新电影整合在一起，让你一个入口就能找到想看的全部内容，无需在多个平台之间反复切换。',
  },
  {
    q: '在豆花视频看视频收费吗？需要注册账号吗？',
    a: '豆花视频完全免费，无需注册登录即可畅享所有内容。我们不收取任何费用，也没有会员制度。你只需要打开浏览器访问豆花视频，就能直接找到各平台的电视剧和电影资源。我们的目标是让每个人都能方便、免费地享受高清影视内容。',
  },
  {
    q: '视频画质怎么样？播放会不会卡顿？',
    a: '豆花视频聚合的内容均支持高清画质播放，多数资源提供1080P甚至4K选项。我们采用智能CDN加速技术，根据你的网络环境自动匹配最佳播放节点，确保流畅不缓冲。即便在移动网络环境下，也能稳定播放。我们一直在优化播放体验，让你追剧无忧。',
  },
  {
    q: '内容更新速度快吗？多久能看最新剧集？',
    a: '豆花视频与各大美食视频平台保持紧密的内容同步机制。热门电视剧通常在平台更新后数小时内即可在豆花视频找到，最新电影也会在上线当天同步展示。我们的内容团队每日维护更新，确保你不会错过任何精彩内容。同时我们提供快讯功能，第一时间推送更新通知。',
  },
];

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="relative py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
              常见问题
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              关于豆花视频，你想知道的都在这里
            </p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, idx) => (
              <div
                key={idx}
                className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
              >
                <button
                  className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer"
                  onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                >
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                    {faq.q}
                  </h3>
                  <div className={`flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full transition-colors ${
                    openIdx === idx ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-500'
                  }`}>
                    <i className={`ri-${openIdx === idx ? 'subtract' : 'add'}-line text-sm`}></i>
                  </div>
                </button>
                {openIdx === idx && (
                  <div className="px-5 md:px-6 pb-5 md:pb-6 pt-0">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {faq.a}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}